import { WhatsAppStatus } from "@/types";

type WhatsAppHealth = {
  status?: string;
  ready?: boolean;
};

const coerceStatus = (value?: string, ready?: boolean): WhatsAppStatus["status"] => {
  if (value === "disconnected" || value === "qr_pending" || value === "authenticating" || value === "ready" || value === "error") {
    return value;
  }
  return ready ? "ready" : "disconnected";
};

const normalizeBase = (base: string) => {
  if (base.startsWith("http")) {
    if (import.meta.env.PROD && /^https?:\/\/(localhost|127\.0\.0\.1|::1)(:\d+)?/i.test(base)) {
      return "/whatsapp";
    }
    return base;
  }
  if (base.startsWith("/")) return base;
  if (import.meta.env.PROD) return "/whatsapp";
  return `http://localhost:${base}`;
};

export async function fetchWhatsAppStatus(
  base: string,
  authHeaders: Record<string, string> = {}
): Promise<WhatsAppStatus | null> {
  const normalized = normalizeBase(base);
  try {
    const response = await fetch(`${normalized}/status`, { headers: { ...authHeaders } });
    if (response.ok) {
      const data = await response.json().catch(() => ({}));
      return {
        status: coerceStatus(data?.status, data?.ready),
        phoneNumber: data?.phoneNumber ?? data?.phoneNumberMasked ?? null,
        messagesSent: Number(data?.messagesSent || 0),
        lastMessageAt: data?.lastMessageAt ?? null,
        lastError: data?.lastError ?? null,
      };
    }
  } catch {
    // Fall through to healthcheck.
  }

  try {
    const response = await fetch(`${normalized}/health`);
    if (!response.ok) return null;
    const data: WhatsAppHealth = await response.json().catch(() => ({}));
    return {
      status: coerceStatus(data?.status, data?.ready),
      phoneNumber: null,
      messagesSent: 0,
      lastMessageAt: null,
      lastError: null,
    };
  } catch {
    return null;
  }
}


